<script setup>
import { ref, onMounted, onBeforeUnmount} from 'vue'
import patientapi from "@/api/patientapi"
import { useCurrentEntryStore } from '@/stores/currentEntry'
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const currentEntryStore = useCurrentEntryStore();

const props = defineProps({
  conceptExpression: {
    type: Object,
    required: true,
  },
  editConceptNameDone: {
    type: Function,
    required: false
  }
});

const emits = defineEmits(['close']);
const focusRef= ref(null);

let doEvolve = true
const newOriginalText = ref(props.conceptExpression.originalText);

async function evolveConceptExprText() {
  if (!doEvolve) return;
  const entryId = currentEntryStore.currentEntryId;
  const conceptExpr = props.conceptExpression;
  const expression_CclId = conceptExpr.expressionCcl.expressionCclId;
  const dbText = conceptExpr.originalText;
  const newText = newOriginalText.value;

  emits('close');

  if (newText !== dbText) {
    doEvolve = false;

    await patientapi.evolveExpression(entryId, expression_CclId, newText, conceptExpr.patientSummaryId);

    currentEntryStore.reloadAfterHistoryChange();

    if (typeof props.editConceptNameDone !== 'undefined') {
      props.editConceptNameDone();
    }
  } 
}

onBeforeUnmount(() => {
  evolveConceptExprText();
});

onMounted(() => {
  focusRef.value.innerRef.focus()
});
</script>


<template>
  <div style="width: 30rem;" class="bg-modal" @click.stop>
    <text-item :txt="t('patient.expressionMoreMenu.rename')" styles="font-mBold main-m" class="mleft-04"/>
    <inputComboBox2 ref="focusRef" v-model="newOriginalText" @keyup.enter="evolveConceptExprText()" :hasDropd=false :hasClearBtn=false class="mtop-06" style="width: 100%;"/>
  </div>
</template>


